import { useEffect, useMemo, useState } from "react";
import {
	Create,
	TextInput,
	TranslatableInputs,
	useGetList,
	useNotify,
	useRedirect,
	useTranslate,
	SimpleForm,
	ArrayInput,
	SimpleFormIterator,
	FormDataConsumer,
} from "react-admin";

import { userPreferences } from "../../utils/fakeUserPrefrences";
import { validateReminderData } from "./reminderValidate";
import { CustomToolbar } from "../../customComponents/CustomToolbar";

export const ReminderCreate = (props) => {
	const [languagesArray, setLanguagesArray] = useState([]);
	const translate = useTranslate();
	const redirect = useRedirect();
	const notify = useNotify();

	const onSuccess = () => {
		notify(translate("reminders.create.success"), "info");
		redirect("/reminders");
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
	};

	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);

	const { data: languagesData } = useGetList("languages", {
		page: 1,
		perPage: 10,
	});

	useEffect(() => {
		setLanguagesArray(
			Object.values(languagesData).map((language) =>
				language.name.slice(0, 2).toLowerCase()
			)
		);
	}, [languagesData]);

	return (
		<Create
			{...props}
			onSuccess={onSuccess}
			onFailure={onFailure}
			title={translate("reminders.create.title")}
		>
			<SimpleForm
				validate={validateReminderData}
				syncWithLocation={false}
				toolbar={<CustomToolbar />}
			>
				<TranslatableInputs
					locales={languagesArray}
					defaultLocale={defaultLocale}
				>
					<TextInput source="title" />
					<ArrayInput source="message">
						<FormDataConsumer>
							{({ formData, ...rest }) => (
								<SimpleFormIterator
									disableReordering={true}
									{...rest}
									disableAdd={
										rest?.fields?.length >= 3 ? true : false
									}
								>
									<TextInput
										source="singleMessage"
										helperText={"Insert your message here"}
									/>
								</SimpleFormIterator>
							)}
						</FormDataConsumer>
					</ArrayInput>
				</TranslatableInputs>
			</SimpleForm>
		</Create>
	);
};
